/**
 * 厳密じゃないけどURL文字列かどうか
 */
export const isUrlString = (str: string): boolean => {
  return str.match(/http[s]?:\/\//) !== null;
};
